.supportContainer {
  margin-top: 64px;
}

.linkText {
  @include nj-button-secondary;

  border: none;
  text-decoration: underline;
}
